import _ from 'ckLodash';
import elementUtils from 'utils/elementUtils';
import selectionUtils from 'utils/selectionUtils';
import utils from 'utils/utils';

var lastCopiedData;

function getTextFromTextNode(range, textNode) {
    if (range.startContainer.equals(textNode) && range.startOffset > 0) {
        if (range.endContainer.equals(textNode)) {
            return textNode.getText().substr(range.startOffset, range.endOffset - range.startOffset);
        }
        return textNode.getText().substr(range.startOffset);
    }
    if (range.endContainer.equals(textNode)) {
        return textNode.getText().substr(0, range.endOffset);
    }
    return textNode.getText();
}

function getWrappingElementsUpToBlock(textNode) {
    var textNodePath = new CKEDITOR.dom.elementPath(textNode);
    var parentBlock = utils.getBlockParent(textNodePath);
    return {
        wrappingElements: _.takeWhile(textNodePath.elements, elem => !parentBlock.equals(elem)),
        textBlock: parentBlock
    };
}

function getInlineStyles(wrapElements) {
    return _.reduce(wrapElements, (acc, elem) => {
        const style = elem.getAttribute('style');
        const cssClass = elem.getAttribute('class');
        if (style) {
            acc.push(style.split(':')[0]);
        } else if (cssClass && _.startsWith(cssClass, 'color_')) {
            acc.push('color');
        }
        return acc;
    }, []) || [];
}

function cloneWrappedTextNode(wrappingElements, range, textNode) {
    let result = new CKEDITOR.dom.text(getTextFromTextNode(range, textNode));
    for (const elem of wrappingElements) {
        result = result.appendTo(elem.clone(false));
    }
    return {
        node: result,
        html: result.$.outerHTML || result.$.textContent
    };
}

function wrapNodeWithStyle(computedStyle, style, result) {
//wrap text node with span with given computed style if it was not overwriten
    var element = new CKEDITOR.dom.element('span');
    element.setAttribute('style', style + ':' + computedStyle);
    result = result.appendTo(element);
    return result;
}

function wrapClonedWithStylesFromTheme(overridingStyles, blockElement, nodeToWrap) {
    const result = _(['font-size', 'font-weight', 'font-family', 'font-style', 'color'])
        .filter(style => !_.includes(overridingStyles, style))
        .reduce((acc, style) => {
            let computedStyle = CKEDITOR.tools.convertRgbToHex(blockElement.getComputedStyle(style));
            return wrapNodeWithStyle(computedStyle, style, acc);
        }, nodeToWrap);
    return {
        node: result,
        html: result.$.outerHTML
    };
}

function retrieveHtmlWithStylesFromTextNode(range, textNode) {
    const {wrappingElements, textBlock} = getWrappingElementsUpToBlock(textNode);
    var overridingStyles = getInlineStyles(wrappingElements);
    const {node: nodeWithOverrides, html: textWithOverrides} = cloneWrappedTextNode(wrappingElements, range, textNode);
    const {html: textWithAllThemeOverrides} = wrapClonedWithStylesFromTheme(overridingStyles, textBlock, nodeWithOverrides);
    return {textWithOverrides, textWithAllThemeOverrides};
}

function shouldNotInterfereInCopy(editor) {
    return selectionUtils.isMultipleBlockSelection(editor, true) || selectionUtils.getSelectedRange(editor).collapsed;
}

function resetLastCopiedData(editor) {
    const blockElement = utils.getBlockParent(selectionUtils.getSelectedRange(editor).startPath());
    lastCopiedData = {
        textWithOverrides: '',
        textWithAllThemeOverrides: '',
        lastCopiedTextNoSpace: utils.removeSpaces(editor.getSelection().getSelectedText()),
        theme: elementUtils.getTheme(blockElement)
    };
    if (utils.isIE()) {
        lastCopiedData.ieHtml = selectionUtils.getSelectedHtml(editor).getHtml();
    }
}

function createLastCopiedFromInsideCkWithInjectedData(editor) {
    resetLastCopiedData(editor);
    if (shouldNotInterfereInCopy(editor)) {
        return null;
    }
    lastCopiedData.hasSavedState = true;
    var textNodes = selectionUtils.getTextNodesInSelection(editor);
    var range = selectionUtils.getSelectedRange(editor);
    _.forEach(textNodes, function (textNode) {
        const currResult = retrieveHtmlWithStylesFromTextNode(range, textNode);
        lastCopiedData.textWithAllThemeOverrides += currResult.textWithAllThemeOverrides;
        lastCopiedData.textWithOverrides += currResult.textWithOverrides;
    });

    return lastCopiedData;
}

function init(editor) {
    editor.on('contentDom', function () {
        var editable = editor.editable();
        _.forEach(['cut', 'copy'], function (evtName) {
            editable.on(evtName, function () {
                createLastCopiedFromInsideCkWithInjectedData(editor);
            });
        });
    });
}

export default {
    createLastCopiedFromInsideCkWithInjectedData: createLastCopiedFromInsideCkWithInjectedData,
    init: init,
    getLastCopiedData: function () {
        return lastCopiedData || {};
    }
};
